import { makeStyles } from "@material-ui/core";
import DoneIcon from "@mui/icons-material/Done";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Autocomplete,
  Box,
  FormControl,
  FormGroup,
  FormLabel,
  Grid,
  Paper,
  styled,
  Switch,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardMedia from "@mui/material/CardMedia";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { REACT_SUBSCRIPTION_MANAGEMENT } from "../../actions/EndPoints";
import CardTwo from "../../assets/CardTwo.svg";
import { default as CustomTextfeild, default as CustomTextfield } from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import {
  createDiscount,
  createFeatures,
  createProduct,
  getDiscounts,
  getFeatures,
} from "../../slices/Subscription/SubscriptionSlice";
import CommonUtil from "../../Util/CommonUtils";
import ViewSubscription from "./ViewSubscription";

const Android12Switch = styled(Switch)(({ mode, theme }) => ({
  padding: 8,
  bottom: 5,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    border: "1px solid #888B8D",
    backgroundColor: "white",
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#888B8D",
    boxShadow: "none",
    width: 14,
    height: 14,
    margin: 2,
    marginTop: 3,
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
    backgroundColor: "#fff", // Change thumb color when checked
    "&:after": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "60%",
      height: "60%",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="5.97" viewBox="0 0 8 5.97"><path fill="%23226BAB" d="M17.772,14.911l-3.381,3.381-1.353-1.352a.956.956,0,0,0-1.352,1.352l2.03,2.029a.955.955,0,0,0,1.352,0l4.057-4.057a.956.956,0,1,0-1.352-1.352Z" transform="translate(-11.405 -14.63)"/></svg>')`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#226BAB !important",
    opacity: 1,
  },
}));



const useStyles = makeStyles((theme) => ({
  title: {
    color: "#c4c4c4 !important",
    fontSize: "20px !important",
    fontWeight: "500 !important",
  },
}));

function CreateSubscription(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [openView, setOpenView] = useState(false);
  const [freeTrial, setFreeTrail] = useState(false);
  const { open, handleClose } = props;

  const dto1 = {
    name: "Walk-In Registration through DL & Passport Scanner on Web",
    quota: 0,
    type_of_quota: "0",
    validity: true,
  };
  const dto2 = {
    name: "Offender Verification",
    quota: 0,
    type_of_quota: "0",
    validity: true,
  };
  const dto3 = {
    name: "Delivery Report",
    quota: 0,
    type_of_quota: "0",
    validity: true,
  };
  const dto4 = {
    name: "Checklist",
    quota: 0,
    type_of_quota: "0",
    validity: true,
  };
  const dto5 = {
    name: "Watchlist",
    quota: 0,
    type_of_quota: "0",
    validity: true,
  };
  const dto6 = {
    name: "Delivery Options for Mobile Application",
    quota: 0,
    type_of_quota: "0",
    validity: true,
  };
  const dto7 = {
    name: "Walk-In Registration through DL on Mobile Application",
    quota: 0,
    type_of_quota: "0",
    validity: true,
  };
  const dto8 = {
    name: "Card Template",
    quota: 0,
    type_of_quota: "0",
    validity: true,
  };
  const dto9 = {
    name: "Atlas Integration",
    quota: 0,
    type_of_quota: "0",
    validity: true,
  };

  const discountPayload = { name: "Discount1", rate: 1, validity: true };

  const createFeatureList = [
    dto1,
    dto2,
    dto3,
    dto4,
    dto5,
    dto6,
    dto7,
    dto8,
    dto9,
  ];

  const { t } = useTranslation();
  const [features, setFeatures] = useState([]);
  const [priceName, setPriceName] = useState("");
  const [priceAmount, setPriceAmount] = useState("");
  const [selectedFeature, setSelectedFeature] = useState([]);
  const [featureNameList, setFeatureNameList] = useState([]);
  const [periodValue, setPeriodValue] = useState("");
  const [currency, setCurrency] = useState("$");
  const [feature1, setFeature1] = useState("");
  const [feature2, setFeature2] = useState("");
  const [feature3, setFeature3] = useState("");
  const [feature4, setFeature4] = useState("");
  const [priceState, setPriceState] = useState(false);
  const [feature5, setFeature5] = useState("");
  const [discountId, setDiscountId] = useState("");

  const [state, setState] = React.useState({
    feature: selectedFeature,
    name: "",
    annual_price: 0,
    monthly_price: 0,
    country: "US",
    currency: "USD",
    discount: "",
    validity: true,
    type: 0,
    period: 0,
    visitLimit: 0,
  });
  const [featureName, setFetureName] = React.useState({});

  const [error, setError] = useState({
    name: false,
    price: false,
    annual_price: false,
    monthly_price: false,
    country: false,
    currency: false,
    periodValue: false,
    visitLimit: false,
    subscriptionType: false,
  });

  useEffect(() => {
    loadFeatures();
  }, []);

  const handleChangePlan = (data) => {
    let plan = "";
    switch (data) {
      case t("MONTHLY"):
        plan = "Monthly";
        break;
      case t("FREE_TRIAL"):
        plan = "Free Trial";
        break;
      default:
        plan = "";
    }
    return plan;
  };

  const handleChangeDropdown = (event, newValue) => {
    const selectPlan = handleChangePlan(newValue.label);
    if (selectPlan === "Yearly") {
      setPeriodValue("Yearly");
      setState({
        ...state,
        type: 2,
        period: 1,
      });
      setFreeTrail(false);
      setError({
        ...error,
        subscriptionType: false,
      });
    } else if (selectPlan === "Monthly") {
      setPeriodValue("Monthly");
      setState({
        ...state,
        type: 1,
        period: 1,
        name: state.name === "Free Trial" ? "" : state.name,
      });
      setFreeTrail(false);
      setError({
        ...error,
        subscriptionType: false,
      });
    } else {
      setState({
        ...state,
        monthly_price: 0,
        name: "Free Trial",
        type: 1,
        period: 1,
      });
      setError({
        ...error,
        price: false,
        subscriptionType: false,
      });
      setFreeTrail(true);
      setPriceAmount(currency + "0");
      setPriceName("Free Trial");

      setPeriodValue("Monthly");
    }
    setError({
      ...error,
      periodValue: false,
      subscriptionType: false,
    });
    if (state.annual_price !== "" || state.monthly_price !== "") {
      setPriceState(true);
    }
  };

  const cancel = (e) => {
    history.push(REACT_SUBSCRIPTION_MANAGEMENT);
  };

  const handleSubmit = () => {
    if (CommonUtil.isEmptyString(state.name)) {
      Toast(t("SUBSCRIPTION_PLAN_NAME"), "error");
      setError({ ...error, name: true });
      return;
    }

    if (CommonUtil.isEmptyString(periodValue)) {
      Toast(t("SELECT_SUBSCRIPTION_Type"), "error");
      setError({ ...error, subscriptionType: true });
      return;
    }

    if (state.annual_price.length > 6 || state.monthly_price.length > 6) {
      Toast(t("SUBSCRIPTION_LESS_THEN_SIX"), "error");
      setError({ ...error, price: true });
      return;
    }

    if (state.annual_price === "" || state.monthly_price === "") {
      Toast(t("SUBSCRIPTION_ENTER_PLAN"), "error");
      setError({ ...error, price: true });
      return;
    }

    if (
      state.annual_price === 0 &&
      state.monthly_price === 0 &&
      freeTrial !== true
    ) {
      Toast(t("SUBSCRIPTION_ENTER_PLAN"), "error");
      setError({ ...error, price: true });
      return;
    }

    if (
      isNaN(parseInt(state.annual_price) && isFinite(state.annual_price)) ||
      isNaN(parseInt(state.monthly_price) && isFinite(state.monthly_price))
    ) {
      Toast(t("SUBSCRIPTION_CAN_NOT_CHARACTER"), "error");
      setError({ ...error, price: true });
      return;
    }

    if (
      !/^\d+$/.test(state.annual_price) ||
      !/^\d+$/.test(state.monthly_price)
    ) {
      Toast(t("SUBSCRIPTION_CAN_NOT_CHARACTER"), "error");
      setError({ ...error, price: true });
      return;
    }

    if (
      isNaN(parseInt(state.visitLimit) && isFinite(state.visitLimit)) &&
      state.visitLimit !== ""
    ) {
      Toast(t("SUBSCRIPTION_VISITOR_NOT_CHARACTER"), "error");
      setError({ ...error, visitLimit: true });
      return;
    }

    if (state.visitLimit === "") {
      Toast(t("SUBSCRIPTION_VISITOR_TYPE"), "error");
      setError({ ...error, visitLimit: true });
      return;
    }

    if (!/^\d+$/.test(state.visitLimit)) {
      Toast(t("SUBSCRIPTION_VISITOR_NOT_CHARACTER"), "error");
      setError({ ...error, visitLimit: true });
      return;
    }

    if (state.visitLimit.length > 6) {
      Toast(t("SUBSCRIPTION_VISITOR_EXCEED_SIX"), "error");
      setError({ ...error, visitLimit: true });
      return;
    }

    if (state.visitLimit === 0) {
      Toast(t("SUBSCRIPTION_VISITOR_TYPE"), "error");
      setError({ ...error, visitLimit: true });
      return;
    }

    if (CommonUtil.isEmptyString(periodValue)) {
      Toast(t("SELECT_SUBSCRIPTION_Type"), "error");
      setError({ ...error, periodValue: true });
      return;
    }

    if (priceState === false) {
      Toast(t("SUBSCRIPTION_ENTER_PRICE"), "error");
      setError({ ...error, price: true });
      return;
    }

    if (CommonUtil.isEmptyString(state.currency)) {
      Toast(t("SUBSCRIPTION_SELECT_CURRENCY"), "error");
      setError({ ...error, price: true });
      return;
    }

    if (CommonUtil.isEmptyArray(state.feature)) {
      Toast(t("SUBSCRIPTION_ATLEAST_ONE_SUBSCRIPTION"), "error");
      return;
    }

    dispatch(createProduct(state))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4026" && data.data) {
          Toast(t("SUBSCRIPTION_CREATE_SUCESS"), "success");
          history.push(REACT_SUBSCRIPTION_MANAGEMENT);
        } else {
          Toast(data.message, "error");
          return;
        }
      });
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
    setError({
      name: false,
    });
  };

  const handleCurrencyChange = (event) => {
    if (event.target.value === t("SUBSCRIPTIONUSD")) {
      setCurrency("$");
      setState({
        ...state,
        currency: "USD",
      });
    } else if (event.target.value === "Euro") {
      setCurrency("€");
      setState({
        ...state,
        currency: "EUR",
      });
    }
  };

  const handleChange2 = (event) => {
    if (periodValue === "Yearly") {
      setState({
        ...state,
        annual_price: event.target.value,
      });
    } else {
      setState({
        ...state,
        monthly_price: event.target.value,
      });
    }
    setPriceAmount(currency + event.target.value);
    setPriceState(true);
    setError({
      ...error,
      price: false,
    });
  };

  const handleToggleChange = (event, featureId, featureName) => {
    if (event.target.checked === true) {
      selectedFeature.push(featureId);
      featureNameList.push(featureName);
    } else {
      const featureIdIndex = selectedFeature.indexOf(featureId);
      if (indexToRemove !== -1) {
        selectedFeature.splice(featureIdIndex, 1);
      }
      const indexToRemove = featureNameList.indexOf(featureName);
      if (indexToRemove !== -1) {
        featureNameList.splice(indexToRemove, 1);
      }
    }
    setSelectedFeature(selectedFeature);
    setFeatureNameList(featureNameList);
    if (featureNameList[0] !== undefined) {
      setFeature1(featureNameList[0]);
    } else {
      setFeature1("");
    }
    if (featureNameList[1] !== undefined) {
      setFeature2(featureNameList[1]);
    } else {
      setFeature2("");
    }
    if (featureNameList[2] !== undefined) {
      setFeature3(featureNameList[2]);
    } else {
      setFeature3("");
    }
    if (featureNameList[3] !== undefined) {
      setFeature4(featureNameList[3]);
    } else {
      setFeature4("");
    }
    if (featureNameList[4] !== undefined) {
      setFeature5(featureNameList[4]);
    } else {
      setFeature5("");
    }
  };

  const loadFeatures = () => {
    const query = {
      pageNumber: 1,
      pageSize: 100,
    };

    dispatch(getFeatures(query))
      .unwrap()
      .then((data) => {
        if (data.code === "200" && data.data) {
          setFeatures(data.data.results);
          if (data.code === "200" && data.data.count === 0) {
            dispatch(createFeatures(createFeatureList))
              .unwrap()
              .then((data) => {
                dispatch(getFeatures(query))
                  .unwrap()
                  .then((updatedData) => {
                    if (updatedData.code === "200" && updatedData.data) {
                      setFeatures(updatedData.data.results);
                    }
                  });
              });
          }
        } else {
          setFeatures([]);
        }
      });

    dispatch(getDiscounts(query))
      .unwrap()
      .then((data) => {
        if (data.code === "200" && data.data) {
          const discountList = data.data.results;
          if (data.data.count === 0) {
            dispatch(createDiscount(discountPayload))
              .unwrap()
              .then((discountdata) => {
                if (discountdata.code === "201") {
                  setDiscountId(discountdata.data.id);
                  setState({
                    ...state,
                    discount: discountdata.data.id,
                  });
                }
              });
          }
          if (discountList.length > 0) {
            setDiscountId(discountList[0].id);
            setState({
              ...state,
              discount: discountList[0].id,
            });
          }
        }
      });
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 40) {
      return text.substring(0, 40) + "...";
    } else {
      return text;
    }
  };

  const handleTextPrice = (text) => {
    if (text && text.length > 9) {
      return text.substring(0, 9) + "...";
    } else {
      return text;
    }
  };
  const calculateInitialHeight = () => {
    return window.innerHeight - 150;
  };

  const [height, setHeight] = useState(calculateInitialHeight);
  const [initialWindowHeight, setInitialWindowHeight] = useState(
    window.innerHeight
  );

  useEffect(() => {
    const handleResize = () => {
      const percentageChange = (window.innerHeight / initialWindowHeight) * 100;

      setHeight(calculateInitialHeight);
      setInitialWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [initialWindowHeight]);

  const subscriptionType = [
    { label: t("MONTHLY") },
    { label: t("FREE_TRIAL") },
  ];

  return (
    <>
      <HeaderToolbar
        title={t("LABELNAVITEMSCREATESUBSCRIPTION")}
        back_button={true}
      />
      <Box
        style={{
          padding: "0px",
          width: "100%",
          height: `${height}px`,
          overflowY: "auto",
          scrollbarWidth: "none",
          borderRadius: "10px",
          marginTop: '10px'
        }}>
        <div
          style={{
            flexGrow: 1,
            overflowY: "auto",
            height: "100%",
            overflowX: "hidden",
          }}
        >
          <Paper>
            <Grid
              container
              rowSpacing={2}
              columnSpacing={2}
              style={{
                width: "85%",
                padding: "20px",
              }}
            >
              <Grid item sm={12} md={6}>
                {freeTrial ? (
                  <CustomTextfeild
                    name={"name"}
                    value={state.name}
                    handleChange={handleChange}
                    type={"text"}
                    required
                    disabled
                  />
                ) : (
                  <CustomTextfeild
                    label={t("SUBSCRIPTIONPLANNAME")}
                    name={"name"}
                    error={error.name}
                    value={state.name}
                    handleChange={handleChange}
                    type={"text"}
                    validation="restrictLength"
                    required
                    autoComplete="off"
                  />
                )}
              </Grid>
              <Grid item sm={12} md={6}>
                <Autocomplete
                  popupIcon={<ExpandMoreIcon />}
                  clearIcon={null}
                  noOptionsText={"No Options found"}
                  name="Subscription Type"
                  options={subscriptionType}
                  onChange={handleChangeDropdown}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required={true}
                      name="Subscription Type"
                      variant="outlined"
                      fullWidth
                      label={t("SELECTSUBSCRIPTIONTYPEMANDATORY")}
                    />
                  )}
                />
              </Grid>
              <Grid item sm={12} md={6}>
                <CustomTextfield
                  name={"price"}
                  value={state.monthly_price}
                  error={error.price}
                  handleChange={handleChange2}
                  handleCurrencyChange={handleCurrencyChange}
                  type={"text"}
                  periodValue={periodValue}
                  validation="subscriptionNumeric"
                  required={true}
                  disabled={freeTrial ? true : false}
                  subscription={true}
                />
              </Grid>
              <Grid item sm={12} md={6}>
                <CustomTextfeild
                  label={t("SUBSCRIPTIONVISITIONCREATION")}
                  name={"visitLimit"}
                  error={error.visitLimit}
                  handleChange={handleChange}
                  validation="text"
                  required={true}
                />
              </Grid>
            </Grid>
          </Paper>

          <Box>
            <Grid container spacing={2} sx={{ margin: "10px 0" }}>
              <Grid
                item
                xs={12}
                md={6}
                lg={6}
                sx={{
                  backgroundColor: "#ffffff",
                  padding: 2,
                  borderRadius: 2,
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    color: "#0F5A9C",
                    fontFamily: "normal normal medium 18px/22px Roboto",
                  }}
                >
                  {t("SUBSCRIPTIONINFROMATION")}
                </Typography>
                <div style={{ maxHeight: 400, marginTop: 16 }}>

                  <FormControl component="fieldset" fullWidth>
                    {features.map((feature) => (
                      <FormGroup key={feature.id} sx={{ marginBottom: 1 }}>
                        <Grid container alignItems="center" spacing={2}>
                          <Grid item xs={8}>
                            <FormLabel
                              component="legend"
                              sx={{
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                fontFamily: "normal normal normal 16px/19px Roboto",
                                fontSize: "14px",
                                color: "#242424 !important",
                                opacity: 1
                              }}
                            >
                              {feature.name}
                            </FormLabel>
                          </Grid>
                          <Grid item xs={4} sx={{ textAlign: "right" }}>
                            <Android12Switch
                              checked={featureName[feature.name]}
                              onChange={(event) =>
                                handleToggleChange(event, feature.id, feature.name)
                              }
                              name={feature.name}
                            />
                          </Grid>
                        </Grid>
                      </FormGroup>
                    ))}
                  </FormControl>
                </div>
              </Grid>
              <Grid item xs={4} md={3} lg={5.9} sx={{
                backgroundColor: "#ffffff",
                padding: 2,
                borderRadius: 2,
                marginLeft: 1
              }}>
                <Box
                  sx={{
                    position: "relative"
                  }}
                >
                  <Card
                    sx={{
                      height: "480px",
                      width: "100%",
                      maxWidth: 360,
                      margin: "auto",
                      borderRadius: "20px"
                    }}
                  >
                    <CardMedia component="img" src={CardTwo} alt="subscription card" sx={{
                      marginTop: "-21px",
                      marginLeft: "-23px",
                      width: "410px"
                    }} />

                    {periodValue === "Monthly" && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: 115,
                          left: "50%",
                          transform: "translateX(-50%)",
                          color: "#fff",
                          fontSize: 18,
                          fontFamily: "Roboto",
                          textAlign: "center",
                        }}
                      >
                        {t("MONTHLY")}
                      </Box>
                    )}

                    <Box
                      sx={{
                        position: "absolute",
                        top: 21,
                        left: "50%",
                        transform: "translateX(-50%)",
                        textAlign: "center",
                        color: "#fff",
                        fontSize: 32,
                        fontWeight: 400,
                        fontFamily: "Roboto",
                      }}
                    >
                      {handleTextPrice(
                        state.name === "Free Trial" ? t("FREE_TRIAL") : state.name
                      )}
                    </Box>

                    <Box
                      sx={{
                        position: "absolute",
                        top: 60,
                        left: "50%",
                        transform: "translateX(-50%)",
                        textAlign: "center",
                        color: "#fff",
                        fontSize: 40,
                        fontWeight: "bold",
                        fontFamily: "Roboto",
                      }}
                    >
                      {priceAmount}
                    </Box>

                    {[feature1, feature2, feature3, feature4, feature5]
                      .filter(Boolean)
                      .map((feature, idx) => (
                        <Grid
                          key={idx}
                          container
                          alignItems="center"
                          spacing={1}
                          sx={{
                            position: "absolute",
                            top: 210 + idx * 40,
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: "90%",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Grid item>
                            <DoneIcon sx={{ fontSize: 20, color: "green" }} />
                          </Grid>
                          <Grid item xs>
                            <Tooltip title={feature} placement="bottom-start">
                              <Typography
                                noWrap
                                sx={{
                                  fontSize: "14px",
                                  color: "#000",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {handleTextOverflow(feature)}
                              </Typography>
                            </Tooltip>
                          </Grid>
                        </Grid>
                      ))}

                    {/* Subscription Button */}
                    <CardActions
                      sx={{
                        justifyContent: "center",
                        marginTop: feature5 ? "400px" : "200px",
                      }}
                    >
                      {state.name && periodValue && (
                        <ViewSubscription
                          featureNameList={featureNameList}
                          planName={priceName}
                          price={priceAmount}
                          visitLimit={state.visitLimit}
                          subscriptionType={periodValue}
                          open={openView}
                        />
                      )}
                    </CardActions>
                  </Card>
                </Box>
                <Box>

                  <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    sx={{ marginTop: 1, marginRight: 2.5 }}
                  >
                    <Grid item>
                      <CancelButtons
                        color="secondary"
                        onClick={cancel}
                        variant="contained"
                      >
                        <Typography>{t("COMMON008")}</Typography>
                      </CancelButtons>
                    </Grid>
                    <Grid item>
                      <SubmitButtons onClick={handleSubmit} variant="contained">
                        <Typography>{t("COMMON007")}</Typography>
                      </SubmitButtons>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Box>
    </>
  );
}
export default CreateSubscription;
